import React from 'react';

import QuestionMultiselect from '../QuestionMultiselect/QuestionMultiselect';
import QuestionPercent from '../QuestionPercent/QuestionPercent';
import QuestionRadio from '../QuestionRadio/QuestionRadio';

const QuestionType = ({
  question,
  userAnswer,
  setUserAnswer,
  setIsAnswerValid,
}) => {
  if (!question) {
    return null;
  }

  let QuestionComponent;
  switch (question.type) {
    case 'radio':
      QuestionComponent = QuestionRadio;
      break;
    case 'percent':
      QuestionComponent = QuestionPercent;
      break;
    case 'multiselect':
      QuestionComponent = QuestionMultiselect;
      break;
    default:
      return null;
  }

  return (
    <QuestionComponent
      question={question}
      userAnswer={userAnswer}
      setUserAnswer={setUserAnswer}
      setIsAnswerValid={setIsAnswerValid}
    />
  );
};

export default QuestionType;
